/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getCurrentUserUsername } from '@/reducers/currentUser'

import ConvertOrganizationButton from './ConvertOrganizationButton'

import type { StateProps } from './types'
import type { ReduxState } from '@/types/redux'

const mapStateToProps = (state: ReduxState): StateProps => {
  const username = getCurrentUserUsername(state) || 'admin'
  const email = username.includes('@') ? username : `${username}@elastic.co`

  return {
    email,
  }
}

export default connect(mapStateToProps)(ConvertOrganizationButton)
